/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ClientSideAvailability = {
  usingMobileKey?: boolean | undefined;
  usingEnvironmentId?: boolean | undefined;
};

/** @internal */
export const ClientSideAvailability$inboundSchema: z.ZodType<
  ClientSideAvailability,
  z.ZodTypeDef,
  unknown
> = z.object({
  usingMobileKey: z.boolean().optional(),
  usingEnvironmentId: z.boolean().optional(),
});
/** @internal */
export type ClientSideAvailability$Outbound = {
  usingMobileKey?: boolean | undefined;
  usingEnvironmentId?: boolean | undefined;
};

/** @internal */
export const ClientSideAvailability$outboundSchema: z.ZodType<
  ClientSideAvailability$Outbound,
  z.ZodTypeDef,
  ClientSideAvailability
> = z.object({
  usingMobileKey: z.boolean().optional(),
  usingEnvironmentId: z.boolean().optional(),
});

export function clientSideAvailabilityToJSON(
  clientSideAvailability: ClientSideAvailability,
): string {
  return JSON.stringify(
    ClientSideAvailability$outboundSchema.parse(clientSideAvailability),
  );
}
export function clientSideAvailabilityFromJSON(
  jsonString: string,
): SafeParseResult<ClientSideAvailability, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ClientSideAvailability$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ClientSideAvailability' from JSON`,
  );
}
